import {OfferType} from "@pg-rp/common-types";

import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {SearchSort} from "../../offer/list/constants/SearchSort";
import {getCountriesList} from "../../region/utils/get_countries_list";
import {VendorDetailOffersListPageSize} from "../constants/VendorDetailOffersListPageSize";
import {IVendorDetailOfferListParams} from "../types/IVendorDetailOfferListParams";

type SortType = SearchSort | "active_hold_archived";

const getVendorOfferListSortName = (searchSort: SortType): string | undefined => {
    switch (searchSort) {
        case SearchSort.PRICE:
            return "price";
        case SearchSort.PRICE_M2:
            return "price_m2";
        case SearchSort.LATEST:
            return "create_date";
        case SearchSort.CONSTRUCTION_DATE:
            return "construction_date_range";
        case "active_hold_archived":
            return "active_hold_archived";
        default:
            return undefined;
    }
};

export function convertToVendorDetailViewOffersPayload(params: {
    vendorId: number | null;
    region: number | null;
    displayType: OfferDisplayType | OfferDisplayType[];
    pageSize?: number;
    type?: OfferType | OfferType[];
    sort?: SortType[];
}): IVendorDetailOfferListParams {
    const {vendorId, region, displayType, pageSize, type, sort} = params;

    const sortNames = sort ? (sort.map((option) => getVendorOfferListSortName(option)).filter((el) => !!el) as string[]) : undefined;

    const typeArray = type ? (Array.isArray(type) ? type : [type]) : [OfferType.FLAT, OfferType.HOUSE];

    const fullQuery: IVendorDetailOfferListParams = {
        vendor: vendorId,
        page_size: pageSize ?? VendorDetailOffersListPageSize,
        country: getCountriesList(),
        ...(region !== null ? {region} : {}),
        display_type: displayType,
        limited_presentation: displayType === OfferDisplayType.FOR_SALE ? false : undefined,
        type: typeArray,
        is_active: true,
        sort: sortNames
    };

    return fullQuery;
}
import {OfferType} from "@pg-rp/common-types";

import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {SearchSort} from "../../offer/list/constants/SearchSort";
import {getCountriesList} from "../../region/utils/get_countries_list";
import {VendorDetailOffersListPageSize} from "../constants/VendorDetailOffersListPageSize";
import {IVendorDetailOfferListParams} from "../types/IVendorDetailOfferListParams";

type SortType = SearchSort | "active_hold_archived";

const getVendorOfferListSortName = (searchSort: SortType): string | undefined => {
    switch (searchSort) {
        case SearchSort.PRICE:
            return "price";
        case SearchSort.PRICE_M2:
            return "price_m2";
        case SearchSort.LATEST:
            return "create_date";
        case SearchSort.CONSTRUCTION_DATE:
            return "construction_date_range";
        case "active_hold_archived":
            return "active_hold_archived";
        default:
            return undefined;
    }
};

export function convertToVendorDetailViewOffersPayload(params: {
    vendorId: number | null;
    region: number | null;
    displayType: OfferDisplayType | OfferDisplayType[];
    pageSize?: number;
    type?: OfferType | OfferType[];
    sort?: SortType[];
}): IVendorDetailOfferListParams {
    const {vendorId, region, displayType, pageSize, type, sort} = params;

    const sortNames = sort ? (sort.map((option) => getVendorOfferListSortName(option)).filter((el) => !!el) as string[]) : undefined;

    const typeArray = type ? (Array.isArray(type) ? type : [type]) : [OfferType.FLAT, OfferType.HOUSE];

    const fullQuery: IVendorDetailOfferListParams = {
        vendor: vendorId,
        page_size: pageSize ?? VendorDetailOffersListPageSize,
        country: getCountriesList(),
        ...(region !== null ? {region} : {}),
        display_type: displayType,
        limited_presentation: displayType === OfferDisplayType.FOR_SALE ? false : undefined,
        type: typeArray,
        is_active: true,
        sort: sortNames
    };

    return fullQuery;
}
